exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p14[data-v-579f27e4]{padding-right:14px}\n", ""]);

// exports
